import Vue from 'vue'
import Router from 'vue-router'

import product_center_routes from './product_center' 
import customer_case_routes from './customer_case'

let routes = [
  {
    path: '/',
    name: '',
    redirect:'/index'
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('@/pages/about_us/index.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/pages/home/index.vue')
  },
  {
    path: '/service_scope',
    name: 'service_scope',
    component: () => import('@/pages/service_scope/index.vue')
  },
]

routes = routes.concat(product_center_routes,customer_case_routes)

Vue.use(Router)

let routerInstance = new Router({
    routes, 
})

function routerAfterEachFunc(to, from) {
    window.scrollTo(0, 0)
}
function routerBeforeEachFunc(to, from, next) {
    next()
}

routerInstance.afterEach(routerAfterEachFunc)
routerInstance.beforeEach(routerBeforeEachFunc)
export default routerInstance



// WEBPACK FOOTER //
// ./src/router/index.js